import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { BlobBackground } from './BlobBackground';
const tools = ['Protocolo de Vaciado Digestivo', 'Filtro de Compras Seguras', 'Mapa de Sensibilidad 11 PM', 'Checklist de Síntomas Diarios', 'Diario de Reacción SOS', 'Inventario de Despensa Limpia'];
export function ToolsIncluded() {
  return <section className="py-24 relative overflow-hidden bg-white/50" data-id="element-210">
      <div className="absolute top-0 right-0 w-96 h-96 opacity-30 z-0 translate-x-1/3 -translate-y-1/3" data-id="element-211">
        <BlobBackground color="var(--color-mint)" data-id="element-212" />
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-213">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-214">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-215">
            Herramientas Prácticas Incluidas
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-216">
            No solo teoría. Plantillas y guías listas para usar que facilitan tu
            proceso.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-217">
          {tools.map((tool, index) => <motion.div key={index} className="bg-cream p-6 rounded-2xl border border-sage/20 flex flex-col items-center text-center gap-4 hover:bg-mint/10 transition-colors duration-300" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-218">
              <CheckCircle2Icon className="text-sage w-8 h-8" data-id="element-219" />
              <span className="font-medium text-forest" data-id="element-220">{tool}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}